<template>
  <div style="width: 1200px; margin: 0 auto">
    <el-table @row-click="rowClick" style="margin-bottom: 20px" :show-header="false" :data="noticeList" :row-style="{height:'100px',cursor:'pointer'}">
      <el-table-column >
        <template slot-scope="scope">
          <p style="font-size: 16px;color: black">{{ scope.row.title }}</p>
          <div>
            <el-tag>{{scope.row.moduleName}}</el-tag>
            {{ scope.row.createTime }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="4" :offset="9">
        <pagination v-show="total>0" :total="total" :page.sync="searchQuery.pageNum" :limit.sync="searchQuery.pageSize"
                    @pagination="getList"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getSearchResult} from "../api";

export default {
  name: 'articles',
  data() {
    return {
      total: 0,
      searchQuery:{
        pageSize:10,
        pageNum:1,
        value:null,
      },
      noticeList: [],

    }
  },
  created() {
    this.getList();

  },
  mounted() {

  },
  methods: {
    rowClick(row ){
      this.$router.push(`/showArt/${row.id}`)
    },
    getList() {
      this.searchQuery.value=window.sessionStorage.getItem("value")
      getSearchResult(this.searchQuery).then(res => {
        this.noticeList = res.data.data.rows
        this.total=res.data.data.total;
        //发布时间去掉时分秒
        for (const dataKey in res.data.data.rows) {
          this.noticeList[dataKey].createTime = res.data.data.rows[dataKey].createTime.split(' ')[0]
        }
      })
    },

  }
}
</script>

<style scoped>
.card{
  width: 80%;
  margin: auto;
}

</style>
